export const TOAST_TIMEOUT = 5_000;
export const TOAST_TEST_ID = 'loginPage-loginActionToastFeedback';
